import type { UserRole } from '@/types'
import { ROUTES } from '@/config/routes'

/**
 * Returns true if the given role is in the list of required roles.
 */
export function canAccess(userRole: UserRole | null, requiredRoles: UserRole[]): boolean {
  if (userRole === null) return false
  return requiredRoles.includes(userRole)
}

/**
 * Returns the default landing route for a given role.
 */
export function getDefaultRouteForRole(role: UserRole | null): string {
  switch (role) {
    case 'superuser':
      return ROUTES.ADMIN.DASHBOARD
    case 'manager':
      return ROUTES.ADMIN.DASHBOARD
    case 'tutor':
      return ROUTES.ADMIN.DASHBOARD
    case 'student':
      return ROUTES.STUDENT.DASHBOARD
    default:
      return ROUTES.AUTH.LOGIN
  }
}
